export async function calculateResignationDates(
  companyPolicy,
  resignationDetails
) {
  return new Promise((resolve) => {
    const {
      salary_release_type_id ,
      salary_release_days ,
      asset_return_type_id ,
      asset_return_days_before ,
      pending_amount_release_type_id ,
      pending_amount_release_days ,
      document_release_type_id ,
      document_release_days ,
      notice_period_days ,
    } = companyPolicy || {};

    const { resignation_date } = resignationDetails || {};

    if (!resignation_date) {
      throw new Error("Resignation date is required");
    }

    const resignationDate = new Date(resignation_date);
    
    if (isNaN(resignationDate.getTime())) {
      throw new Error("Invalid resignation date");
    }

    const lastWorkingDate = new Date(resignationDate);
    const noticePeriod = resignationDetails?.notice_period_days
      ? parseInt(resignationDetails?.notice_period_days)
      : resignationDetails?.employment_status === "permanent"
      ? parseInt(notice_period_days) 
      : 0;
    
    lastWorkingDate.setDate(lastWorkingDate.getDate() + noticePeriod);

    const adjustDate = (date, days) => {
      let newDate = new Date(date);
      const parsedDays = parseInt(days) || 0;
      newDate.setDate(newDate.getDate() + parsedDays);
      return newDate.toISOString().split("T")[0];
    };

    const result = {
      last_working_date: resignationDetails?.last_working_date
        ? resignationDetails?.last_working_date
        : resignationDetails?.employment_status === "permanent"
        ? adjustDate(resignationDate, parseInt(notice_period_days) )
        : adjustDate(resignationDate, 0),
      salary_release_date:
        salary_release_type_id === 1
          ? adjustDate(lastWorkingDate, 1)
          : adjustDate(lastWorkingDate, parseInt(salary_release_days) ),
      asset_return_due_date:
        resignationDetails?.employment_status !== "permanent"
          ? adjustDate(resignationDate, 0)
          : asset_return_type_id === 1
          ? adjustDate(lastWorkingDate, 0)
          : adjustDate(lastWorkingDate, -(parseInt(asset_return_days_before))),
      pending_amount_release_date:
        pending_amount_release_type_id === 1
          ? adjustDate(lastWorkingDate, 1)
          : pending_amount_release_type_id === 2
          ? adjustDate(lastWorkingDate, parseInt(pending_amount_release_days))
          : salary_release_type_id === 1
          ? adjustDate(lastWorkingDate, 1)
          : adjustDate(lastWorkingDate, parseInt(salary_release_days) ),
      document_release_date:
        document_release_type_id === 1
          ? adjustDate(lastWorkingDate, 0)
          : adjustDate(lastWorkingDate, parseInt(document_release_days) ),
    };

    resolve(result);
  });
}
